/**
 * influencer-popup.js — v2 (KYEESE Style)
 * Dawn 主题专属 Influencer 折扣弹窗 — 样式适配 kyeese.com 品牌风格
 * 
 * 工作流程：
 *   1. 用户通过 ?ref=博主名 访问店铺
 *   2. JS 查找 JSON 配置中是否有该博主
 *   3. 有 → 弹窗（每次访问都弹，完整展示 Redeem 流程）
 *   4. 点击 Redeem → 显示折扣码 → 写入 Cookie（供结算页自动应用）
 *   5. 关闭弹窗 → 下次再来重复完整流程
 * 
 * 配置位置：Shopify 后台 → 自定义主题 → 主题设置 → Influencer Discount Popup
 * JSON 格式：[{"name":"博主名","code":"折扣码"}]
 * 
 * ⚠️ 为何必须手动配置 JSON？
 *   Shopify 折扣码仅可通过 Admin API（需密钥）查询，
 *   前端 JS 无法自动读取。手动配置是最轻量的方式。
 */

(function() {
  'use strict';

  // ============================================================
  // 1. 读取 Influencer 配置
  // ============================================================
  var rawConfig = window.__INFLUENCER_CONFIG || '[]';
  var INFLUENCERS = [];
  try {
    INFLUENCERS = JSON.parse(rawConfig);
  } catch(e) {
    try {
      INFLUENCERS = JSON.parse(atob(rawConfig));
    } catch(e2) {
      console.warn('[Influencer Popup] 配置解析失败:', e2);
    }
  }

  // ============================================================
  // 2. Cookie 工具（仅用于结算页自动应用折扣，不影响弹窗行为）
  // ============================================================
  var CookieUtil = {
    set: function(name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
    },
    get: function(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) {
          return decodeURIComponent(c.substring(nameEQ.length));
        }
      }
      return null;
    }
  };

  // ============================================================
  // 3. 从 URL 获取 ref 参数
  // ============================================================
  function getRefFromURL() {
    var params = new URLSearchParams(window.location.search);
    return params.get('ref') || null;
  }

  // ============================================================
  // 4. 查找对应 Influencer
  // ============================================================
  function findInfluencer(refName) {
    if (!refName) return null;
    var normalized = refName.trim().toLowerCase();
    for (var i = 0; i < INFLUENCERS.length; i++) {
      if (INFLUENCERS[i].name.toLowerCase() === normalized) {
        return INFLUENCERS[i];
      }
    }
    return null;
  }

  // ============================================================
  // 5. 弹窗 HTML 渲染（KYEESE 品牌风格）
  // ============================================================
  function renderPopup(influencer) {
    // 如果弹窗已存在，不重复创建
    var existing = document.getElementById('influencer-popup-overlay');
    if (existing) return;

    var discountText = influencer.discount || '15% OFF';
    var message = influencer.message || 'sent you an exclusive discount!';
    var code = influencer.code || '';

    var overlay = document.createElement('div');
    overlay.id = 'influencer-popup-overlay';
    overlay.className = 'influencer-popup-overlay';
    overlay.style.cssText = [
      'position: fixed; top: 0; left: 0; width: 100%; height: 100%;',
      'background: rgba(0,0,0,0.5); z-index: 999999;',
      'display: flex; align-items: center; justify-content: center;',
      'animation: influencerFadeIn 0.3s ease;'
    ].join('');

    var modal = document.createElement('div');
    modal.id = 'influencer-popup-modal';
    modal.className = 'influencer-popup-modal';
    modal.style.cssText = [
      'background: #fffbf5; border-radius: 16px;',
      'padding: 0; max-width: 420px; width: 90%;',
      'position: relative; box-shadow: 0 20px 60px rgba(0,0,0,0.3);',
      'text-align: center; overflow: hidden;',
      'font-family: Montserrat, "Helvetica Neue", Arial, sans-serif;',
      'animation: influencerSlideUp 0.3s ease;'
    ].join('');

    // 顶部颜色条 — KYEESE 珊瑚红
    var topBar = document.createElement('div');
    topBar.style.cssText = [
      'height: 6px; background: #FF595A;'
    ].join('');

    // 关闭按钮
    var closeBtn = document.createElement('button');
    closeBtn.id = 'influencer-popup-close';
    closeBtn.innerHTML = '&times;';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.style.cssText = [
      'position: absolute; top: 16px; right: 16px;',
      'background: none; border: none; font-size: 28px;',
      'cursor: pointer; color: #999; line-height: 1;',
      'padding: 4px 8px; z-index: 10;',
      'font-family: Montserrat, sans-serif;',
      'transition: color 0.2s;'
    ].join('');
    closeBtn.addEventListener('mouseenter', function() { this.style.color = '#FF595A'; });
    closeBtn.addEventListener('mouseleave', function() { this.style.color = '#999'; });
    closeBtn.addEventListener('click', closePopup);

    // 内容容器
    var content = document.createElement('div');
    content.style.cssText = 'padding: 32px 32px 28px;';

    // Emoji / 图标
    var iconDiv = document.createElement('div');
    iconDiv.style.cssText = 'font-size: 48px; margin-bottom: 12px;';
    iconDiv.textContent = '🎉';

    // 标题 — 博主名使用 KYEESE 珊瑚红
    var title = document.createElement('h2');
    title.style.cssText = [
      'font-size: 22px; font-weight: 700; color: #1a1a1a;',
      'margin: 0 0 8px; line-height: 1.3;',
      'font-family: Montserrat, "Helvetica Neue", Arial, sans-serif;'
    ].join('');
    title.innerHTML = '<span style="color: #FF595A; font-weight: 800;">@' + escapeHtml(influencer.name) + '</span> ' + escapeHtml(message);

    // 折扣金额 / 百分比 — KYEESE 珊瑚红背景
    var discountBadge = document.createElement('div');
    discountBadge.style.cssText = [
      'display: inline-block; background: #FF595A;',
      'color: #fff; font-size: 28px; font-weight: 800;',
      'padding: 8px 24px; border-radius: 50px;',
      'margin: 16px 0; letter-spacing: 1px;',
      'font-family: Montserrat, "Helvetica Neue", Arial, sans-serif;'
    ].join('');
    discountBadge.textContent = discountText;

    // 折扣码显示区域 — KYEESE 珊瑚红边框 + 浅色背景
    var codeBox = document.createElement('div');
    codeBox.id = 'influencer-code-box';
    codeBox.style.cssText = [
      'display: none;',
      'background: #fff5f5; border: 2px dashed #FF595A;',
      'border-radius: 12px; padding: 16px 20px;',
      'margin: 16px 0 8px; cursor: pointer;',
      'transition: all 0.3s ease; position: relative;'
    ].join('');

    var codeLabel = document.createElement('div');
    codeLabel.style.cssText = [
      'font-size: 12px; color: #999; margin-bottom: 4px;',
      'text-transform: uppercase; letter-spacing: 1px;',
      'font-family: Montserrat, sans-serif;'
    ].join('');
    codeLabel.textContent = 'Your Discount Code';

    var codeValue = document.createElement('div');
    codeValue.id = 'influencer-code-value';
    codeValue.style.cssText = [
      'font-size: 28px; font-weight: 800; color: #FF595A;',
      'letter-spacing: 3px; font-family: "Courier New", monospace;',
      'max-width: 100%;',
      (window.innerWidth <= 480) ? 'word-break: break-all; overflow-wrap: break-word;' : ''
    ].join('');
    codeValue.textContent = code;

    var codeHint = document.createElement('div');
    codeHint.style.cssText = [
      'font-size: 12px; color: #999; margin-top: 6px;',
      'font-family: Montserrat, sans-serif;'
    ].join('');
    codeHint.textContent = 'Click to copy';

    codeBox.appendChild(codeLabel);
    codeBox.appendChild(codeValue);
    codeBox.appendChild(codeHint);

    codeBox.addEventListener('click', function() {
      copyToClipboard(code);
    });

    // 确认提示
    var copiedMsg = document.createElement('div');
    copiedMsg.id = 'influencer-copied-msg';
    copiedMsg.style.cssText = [
      'display: none; color: #22c55e; font-size: 14px;',
      'font-weight: 600; margin: 8px 0 0;',
      'font-family: Montserrat, sans-serif;'
    ].join('');
    copiedMsg.textContent = '✓ Copied!';

    // 手动粘贴提示
    var autoMsg = document.createElement('div');
    autoMsg.style.cssText = [
      'font-size: 13px; color: #888; margin-top: 12px;',
      'font-style: italic; font-family: Montserrat, sans-serif;'
    ].join('');
    autoMsg.textContent = 'Copy & paste this code at checkout';

    // Redeem 按钮 — KYEESE 珊瑚红 + 17px 圆角
    var redeemBtn = document.createElement('button');
    redeemBtn.id = 'influencer-redeem-btn';
    redeemBtn.textContent = 'Redeem Coupon';
    redeemBtn.style.cssText = [
      'background: #FF595A; color: #fff; border: none;',
      'border-radius: 17px; padding: 14px 40px;',
      'font-size: 16px; font-weight: 600; cursor: pointer;',
      'transition: transform 0.2s, box-shadow 0.2s, background 0.2s;',
      'margin: 16px 0 0; width: 100%; max-width: 280px;',
      'font-family: Montserrat, "Helvetica Neue", Arial, sans-serif;'
    ].join('');
    redeemBtn.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
      this.style.boxShadow = '0 6px 20px rgba(255,89,90,0.4)';
      this.style.background = '#e04e4f';
    });
    redeemBtn.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = 'none';
      this.style.background = '#FF595A';
    });
    redeemBtn.addEventListener('click', function() {
      // 显示折扣码
      codeBox.style.display = 'block';
      redeemBtn.style.display = 'none';
      autoMsg.style.display = 'block';

      // 写入 Cookie（7天有效）
      if (code) {
        CookieUtil.set('influencer_discount_code', code, 7);
        CookieUtil.set('influencer_name', influencer.name, 7);
        autoApplyDiscount();
      }
    });

    // Footer — KYEESE 暖色系
    var footer = document.createElement('div');
    footer.style.cssText = [
      'background: #fff5f0; padding: 12px;',
      'font-size: 11px; color: #aaa; border-top: 1px solid #f0e0d8;',
      'font-family: Montserrat, sans-serif;'
    ].join('');
    footer.textContent = 'Exclusive offer — one-time use only';

    // 组装
    content.appendChild(iconDiv);
    content.appendChild(title);
    content.appendChild(discountBadge);
    content.appendChild(codeBox);
    content.appendChild(copiedMsg);
    content.appendChild(redeemBtn);
    content.appendChild(autoMsg);

    modal.appendChild(topBar);
    modal.appendChild(closeBtn);
    modal.appendChild(content);
    modal.appendChild(footer);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // 点击 overlay 关闭（但不影响 modal 内点击）
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closePopup();
      }
    });

    // ⭐ 每次弹窗都完整展示 Redeem 按钮 + 折扣码隐藏
    //    不读取 Cookie 跳过流程，确保每次访问体验一致
    //    Cookie 仅用于未来扩展（如结算页自动应用折扣）
  }

  // ============================================================
  // 6. 工具函数
  // ============================================================
  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() {
        showCopiedMsg();
      }).catch(function() {
        fallbackCopy(text);
      });
    } else {
      fallbackCopy(text);
    }
  }

  function fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      showCopiedMsg();
    } catch(e) {
      // silently fail
    }
    document.body.removeChild(textarea);
  }

  function showCopiedMsg() {
    var msg = document.getElementById('influencer-copied-msg');
    if (msg) {
      msg.style.display = 'block';
      setTimeout(function() {
        msg.style.display = 'none';
      }, 2000);
    }
  }

  function closePopup() {
    var overlay = document.getElementById('influencer-popup-overlay');
    if (overlay) {
      overlay.style.opacity = '0';
      setTimeout(function() {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }, 300);
    }
  }

  // ============================================================
  // 7. 注入动画样式（仅一次）
  // ============================================================
  function injectStyles() {
    if (document.getElementById('influencer-popup-styles')) return;
    var style = document.createElement('style');
    style.id = 'influencer-popup-styles';
    style.textContent = [
      '@keyframes influencerFadeIn {',
      '  from { opacity: 0; }',
      '  to { opacity: 1; }',
      '}',
      '@keyframes influencerSlideUp {',
      '  from { opacity: 0; transform: translateY(30px) scale(0.95); }',
      '  to { opacity: 1; transform: translateY(0) scale(1); }',
      '}',
      '@media (max-width: 480px) {',
      '  #influencer-popup-modal {',
      '    max-width: 95%;',
      '  }',
      '  #influencer-popup-close {',
      '    font-size: 36px !important;',
      '    top: 8px !important;',
      '    right: 8px !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ============================================================
  // 9. 自动应用折扣：Cookie → Cart API（购物车非空时）
  // ============================================================
  function autoApplyDiscount() {
    var code = CookieUtil.get('influencer_discount_code');
    if (!code) return;
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      if (cart.item_count > 0) {
        var applied = false;
        if (cart.discount_codes) {
          for (var i = 0; i < cart.discount_codes.length; i++) {
            if (cart.discount_codes[i].code === code) { applied = true; break; }
          }
        }
        if (!applied) {
          fetch('/cart/update.js?discount_code=' + encodeURIComponent(code), { method: 'POST' });
        }
      }
    });
  }

  // ============================================================
  // 8. 主入口
  // ============================================================
  function init() {
    injectStyles();

    var refName = getRefFromURL();
    if (!refName) return;

    var influencer = findInfluencer(refName);
    if (!influencer) return;

    // 延迟一点确保页面完全渲染
    setTimeout(function() {
      renderPopup(influencer);
    }, 800);
  }

  // DOM Ready 后执行：先尝试自动应用折扣，再显示弹窗
  function onReady() {
    autoApplyDiscount();
    init();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

})();
